import { render, staticRenderFns } from "./AccreditationDetailsRow.vue?vue&type=template&id=f1c58340&scoped=true"
import script from "./AccreditationDetailsRow.vue?vue&type=script&lang=js"
export * from "./AccreditationDetailsRow.vue?vue&type=script&lang=js"
import style0 from "./AccreditationDetailsRow.vue?vue&type=style&index=0&id=f1c58340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c58340",
  null
  
)

export default component.exports